import React from 'react';
import {
    BrowserRouter,
    Switch,
    Route
} from "react-router-dom";
import DefaultLayout from './container/DefaultLayout/DefaultLayout'
import './App.css';

function App() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" name="Home" component={DefaultLayout} />
            </Switch>
        </BrowserRouter>
    );
}

export default App;
